import React, { useRef, useState } from 'react';
import { GoogleLogo } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { googleAuthError } from '../utils/googleAuth';

export const GoogleSignInButton = ({ intent = 'signin', testId, className = '' }) => {
  const { beginGoogle } = useAuth();
  const { language, t } = useLanguage();
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const start = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError('');
    try {
      let referralCode;
      try { referralCode = localStorage.getItem('paperpal_referral_code'); } catch (_) { /* Optional metadata. */ }
      await beginGoogle({ language, intent, referralCode });
    } catch (failure) {
      setError(googleAuthError(failure, language));
      pending.current = false;
      setBusy(false);
    }
  };

  const label = intent === 'link'
    ? (language === 'fr' ? 'Associer Google' : 'Connect Google')
    : t('auth.google');
  return (
    <div className={className}>
      <button type="button" onClick={start} disabled={busy} aria-busy={busy}
        className="w-full flex items-center justify-center gap-3 px-5 py-4 border border-pp-border rounded-xl hover:bg-pp-secondary transition-colors disabled:opacity-60"
        data-testid={testId}>
        <GoogleLogo size={20} weight="bold" className="text-pp-text shrink-0" aria-hidden="true" />
        <span className="font-medium text-pp-text" data-testid={`${testId}-label`}>
          {busy ? (language === 'fr' ? 'Connexion…' : 'Connecting…') : label}
        </span>
      </button>
      {error && <p role="alert" className="mt-3 text-sm text-pp-error" data-testid={`${testId}-error`}>{error}</p>}
    </div>
  );
};